const roundNumber = (value) => Math.round(Number(value));

const positiveNumberOrUndefined = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0
    ? Math.round(numericValue)
    : undefined;
};

const operationOrder = ['rotate', 'crop', 'resize', 'color', 'effect', 'watermark'];

export const buildImageOperations = ({ enabledOperations = [] }) => {
  const resizeOperation = enabledOperations.find((operation) => operation.type === 'resize');
  const hasSmartFrame = Boolean(resizeOperation?.useSmartFrame);

  return [...enabledOperations]
    .sort((a, b) => operationOrder.indexOf(a.type) - operationOrder.indexOf(b.type))
    .map((operation) => {
      switch (operation.type) {
        case 'rotate':
          return { type: 'rotate', angle: operation.angle };

        case 'crop': {
          const width = positiveNumberOrUndefined(operation.width);
          const height = positiveNumberOrUndefined(operation.height);
          if (!width || !height) return null;

          return {
            type: 'crop',
            x: Math.max(0, roundNumber(operation.x || 0)),
            y: Math.max(0, roundNumber(operation.y || 0)),
            width,
            height,
            targetWidth: !hasSmartFrame ? positiveNumberOrUndefined(operation.targetWidth) : undefined,
            targetHeight: !hasSmartFrame ? positiveNumberOrUndefined(operation.targetHeight) : undefined,
            fillColor: !hasSmartFrame ? (operation.fillColor || undefined) : undefined,
          };
        }

        case 'resize':
          return {
            type: 'resize',
            width: positiveNumberOrUndefined(operation.width),
            height: positiveNumberOrUndefined(operation.height),
            useSmartFrame: Boolean(operation.useSmartFrame),
            blur: Number(operation.blur) || 0,
          };

        case 'effect':
          return {
            type: 'effect',
            effect: operation.effect,
            mood: operation.mood,
            brightness: operation.brightness,
            contrast: operation.contrast,
            saturation: operation.saturation,
          };

        case 'watermark':
          return {
            type: 'watermark',
            text: operation.text,
            useImage: operation.useImage,
            imageFileId: operation.imageFileId,
            imageFileName: operation.imageFileName,
            position: operation.position,
            customX: operation.customX,
            customY: operation.customY,
            opacity: operation.opacity,
          };

        default:
          return null;
      }
    })
    .filter(Boolean);
};
